import * as yup from 'yup'
import { DGStackingRuleFormProfile } from './dg-stacking-rules-table-form.profile'

export const schema: yup.ObjectSchema<DGStackingRuleFormProfile> = yup.object({
  id: yup.string().optional(),
  maxTiers: yup
    .number()
    .typeError('Max tiers must be a number')
    .required('Max tiers is required')
    .min(0, 'Max tiers must be 0 or greater'),
  isStackingOnTopAllowed: yup.boolean().required(),
})
